import PropTypes from 'prop-types'

import StatusIndicator from './StatusIndicator'

import i18n from '@/i18n'

export function LeadStatus({
  status
}) {
  return (
    <StatusIndicator
      color={status === 'Ongoing' ? 'info' : status === 'Signed' ? 'success' : status === 'Rejected' ? 'danger' : 'default'}
      label={i18n.t(status)}
    />
  )
}

LeadStatus.propTypes = {
  status: PropTypes.string.isRequired
}

export default LeadStatus